import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@progress/kendo-react-tooltip';
import React, { useEffect } from 'react';
import { STooltipError } from './TooltipError.styled';
import { useForceRefresh } from '../../common/useForceRefresh';

interface IProps {
  message: string;
  absolutePos?: boolean;
}

const TooltipError: React.FC<IProps> = ({ message, absolutePos = true }) => {
  const { refresh, isVisible } = useForceRefresh();

  useEffect(() => {
    refresh();
  }, [message]);

  return (
    <div style={{ position: 'relative' }}>
      {isVisible && (
        <STooltipError absolutePos={absolutePos}>
          <Tooltip anchorElement="target" position="top" openDelay={0} style={{ maxWidth: '300px' }}>
            <FontAwesomeIcon title={message} icon={faExclamationTriangle} size="sm" />
          </Tooltip>
        </STooltipError>
      )}
    </div>
  );
};

export default TooltipError;
